/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupContractType } from './GroupContractType';
import {
    GroupContractTypeFromJSON,
    GroupContractTypeFromJSONTyped,
    GroupContractTypeToJSON,
    GroupContractTypeToJSONTyped,
} from './GroupContractType';

/**
 * 
 * @export
 * @interface CreateGroupContractCommand
 */
export interface CreateGroupContractCommand {
    /**
     * 
     * @type {GroupContractType}
     * @memberof CreateGroupContractCommand
     */
    type: GroupContractType;
    /**
     * Plateforme owning the contract. Required in admin mode; in broker mode the back deduces it from the connected broker.
     * @type {string}
     * @memberof CreateGroupContractCommand
     */
    plateformeId?: string;
    /**
     * Subscriber (legal or physical entity). Optional at draft creation, set later in the process.
     * @type {string}
     * @memberof CreateGroupContractCommand
     */
    subscriberId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupContractCommand
     */
    partnerIdentifier?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateGroupContractCommand
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateGroupContractCommand
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupContractCommand
     */
    periodicityId?: string;
    /**
     * Notice duration value (e.g. 2 for "2 months"). Default 1.
     * @type {number}
     * @memberof CreateGroupContractCommand
     */
    noticeDurationValue?: number;
    /**
     * Notice duration unit. 1=Days, 2=Weeks, 3=Months, 4=Years. Default 3 (Months).
     * @type {number}
     * @memberof CreateGroupContractCommand
     */
    noticeDurationUnit?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateGroupContractCommand
     */
    mainDueDateDay?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateGroupContractCommand
     */
    mainDueDateMonth?: number;
    /**
     * Collective tunnels associated to the contract. Optional at draft creation.
     * @type {Array<string>}
     * @memberof CreateGroupContractCommand
     */
    tunnelIds?: Array<string>;
    /**
     * Brokers enabled on this contract (admin mode only). Null = broker mode (auto-enable creator)
     * @type {Array<string>}
     * @memberof CreateGroupContractCommand
     */
    brokerIds?: Array<string>;
    /**
     * Deprecated — the creation mode (admin/broker/company) is now arbitrated server-side
     * by the ACTIVE role (role switch). The field is ignored by the backend and kept only
     * for serialization compatibility with non-migrated clients.
     * 
     * @type {boolean}
     * @memberof CreateGroupContractCommand
     * @deprecated
     */
    isAdminContext?: boolean;
}



/**
 * Check if a given object implements the CreateGroupContractCommand interface.
 */
export function instanceOfCreateGroupContractCommand(value: object): value is CreateGroupContractCommand {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function CreateGroupContractCommandFromJSON(json: any): CreateGroupContractCommand {
    return CreateGroupContractCommandFromJSONTyped(json, false);
}

export function CreateGroupContractCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGroupContractCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'type': GroupContractTypeFromJSON(json['type']),
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'subscriberId': json['subscriberId'] == null ? undefined : json['subscriberId'],
        'partnerIdentifier': json['partnerIdentifier'] == null ? undefined : json['partnerIdentifier'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'periodicityId': json['periodicityId'] == null ? undefined : json['periodicityId'],
        'noticeDurationValue': json['noticeDurationValue'] == null ? undefined : json['noticeDurationValue'],
        'noticeDurationUnit': json['noticeDurationUnit'] == null ? undefined : json['noticeDurationUnit'],
        'mainDueDateDay': json['mainDueDateDay'] == null ? undefined : json['mainDueDateDay'],
        'mainDueDateMonth': json['mainDueDateMonth'] == null ? undefined : json['mainDueDateMonth'],
        'tunnelIds': json['tunnelIds'] == null ? undefined : json['tunnelIds'],
        'brokerIds': json['brokerIds'] == null ? undefined : json['brokerIds'],
        'isAdminContext': json['isAdminContext'] == null ? undefined : json['isAdminContext'],
    };
}

export function CreateGroupContractCommandToJSON(json: any): CreateGroupContractCommand {
    return CreateGroupContractCommandToJSONTyped(json, false);
}

export function CreateGroupContractCommandToJSONTyped(value?: CreateGroupContractCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': GroupContractTypeToJSON(value['type']),
        'plateformeId': value['plateformeId'],
        'subscriberId': value['subscriberId'],
        'partnerIdentifier': value['partnerIdentifier'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'periodicityId': value['periodicityId'],
        'noticeDurationValue': value['noticeDurationValue'],
        'noticeDurationUnit': value['noticeDurationUnit'],
        'mainDueDateDay': value['mainDueDateDay'],
        'mainDueDateMonth': value['mainDueDateMonth'],
        'tunnelIds': value['tunnelIds'],
        'brokerIds': value['brokerIds'],
        'isAdminContext': value['isAdminContext'],
    };
}

